export const customClassSummary = [
  {
    value: 'STRING',
    text: 'gd-table__summary-row-list-item-amount negative',
  },
  {
    value: 'CURRENCY',
    text: 'gd-table__summary-row-list-item-amount negative',
  },
  {
    value: 'NEGATIVE_NUMBER',
    text: 'gd-table__summary-row-list-item-amount negative',
  },
];

export const customClassCurrency = [
  {
    value: 'CURRENCY',
    text: 'gd-currency-code-cell__negative-bracket',
  },
  {
    value: 'NEGATIVE_NUMBER',
    text: 'gd-currency-code-cell__negative-bracket',
  },
  {
    value: 'CURRENCY_UNIT',
    text: 'gd-currency-code-cell__negative-bracket',
  },
  {
    value: 'DATEAMONUTARRAY',
    text: 'gd-currency-code-cell__negative-bracket',
  },
  {
    value: 'DATE_AMOUNT',
    text: 'gd-currency-code-cell__negative-bracket',
  }
];

export const customClassTabular = [
  {
    value: 'OTHER',
    text: 'gd-table__container-cell__negative-bracket',
  },
];

export const customClassRSP = [
  {
    value: 'CURRENCY',
    text: 'gd-detail-view__item-data_negative_bracket',
  },
  {
    value: 'NEGATIVE_NUMBER',
    text: 'gd-detail-view__item-data_negative_bracket',
  },
];

export function customFormatclass(customClassArray, classkey) {
  const foundClass = customClassArray.find((item) => {
    return item.value === classkey;
  });

  return foundClass && foundClass.text;
}
